import io from 'socket.io-client'
import { baseURL } from './axios'
import initSocketIO from './io'

/* eslint-disable no-console */
export default () => {
  const ioToken = localStorage.getItem('ioToken') || sessionStorage.getItem('ioToken')
  if (ioToken) {
    const socket = io(`${baseURL}?token=${ioToken}`)

    socket.on('connect', function() {
      console.log('io: Connected')
    })
    socket.on('exception', function(data) {
      console.log('io: Exception', data)
    })
    socket.on('disconnect', function() {
      console.log('io: Disconnected')
    })

    return initSocketIO(socket)
  }
}
